import React, { useMemo } from "react"
import moment from "moment"
import tickMark from "images/tickMark.png"
import Pill from "components/Pill"
import { DATE_FORMATS } from "config/constants"
interface Incident {
	incident: string
	date: string
	isPoliceRequested?: boolean
	actionTaken?: boolean
	controlInformed?: boolean
}

interface Props {
	incidents: Incident[]
}

const getActions = (incident: Incident) => {
	const actions = []

	if (incident.isPoliceRequested) actions.push({ label: "Police Requested", key: "police" })
	if (incident.actionTaken) actions.push({ label: "Action Taken", key: "action" })
	if (incident.controlInformed) actions.push({ label: "Control Informed", key: "control" })

	return actions
}

const IncidentsSection = ({ incidents }: Props) => {
	if (!incidents.length) return null

	const incidentWithActions = useMemo(() => {
		return incidents.map(incident => ({
			incident,
			actions: getActions(incident),
		}))
	}, [incidents])

	return (
		<div>
			<div className="flex justify-between bg-[#B2DDFF] px-4 py-3">
				<div className="text-sm font-medium">INCIDENTS</div>
				<div className="flex justify-end space-x-6">
					<div className="flex space-x-2 text-3 font-medium">
						<span>TOTAL INCIDENTS:</span>
						<span> {incidents.length} </span>
					</div>
				</div>
			</div>

			{incidentWithActions.map(({ incident, actions }, idx) => (
				<div key={idx} className="flex flex-col">
					<div className="pt-5 text-lg font-normal text-black">
						• {incident.incident} at {moment(incident.date).format(DATE_FORMATS.hh_mm_DD_MM_YYYY)}•
					</div>
					<div className="flex flex-wrap space-x-2 pt-5 text-lg font-medium">
						{actions.map(action => (
							<Pill
								key={action.key}
								label={action.label}
								icon={<img src={tickMark} alt="tick" className="h-4 w-4" />}
								iconPosition="left"
								className="bg-[#ECFDF3] px-3 py-1  text-[#027A48]"
							/>
						))}
					</div>
				</div>
			))}
		</div>
	)
}

export default IncidentsSection
